/**
 * Probe order: standard host (52641 → 54987), then guest account (52642 → 55625).
 * Must match host-electron App.LOCAL_SERVER_PORTS_STANDARD then LOCAL_SERVER_PORTS_GUEST.
 */
export const HOST_LOCAL_AUTH_PORTS = [52641, 54987, 52642, 55625] as const;

let cachedPort: (typeof HOST_LOCAL_AUTH_PORTS)[number] | null = null;

export async function getHostLocalAuthPort(): Promise<(typeof HOST_LOCAL_AUTH_PORTS)[number]> {
  if (cachedPort !== null) return cachedPort;
  for (const port of HOST_LOCAL_AUTH_PORTS) {
    try {
      const r = await fetch(`http://localhost:${port}/auth-status`, {
        signal: AbortSignal.timeout(2000),
      });
      if (r.ok) {
        cachedPort = port;
        return port;
      }
    } catch {
      /* try next */
    }
  }
  return HOST_LOCAL_AUTH_PORTS[0];
}
